import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { ButtonTertiaryOnDarkS, IconIdentifier } from '@steelbuy/ui-primitive';
import { buildClassStringFromClassMap, useScrollPosition } from '@steelbuy/util';
import { RoutePath } from '../../../router/Routes';
import { useNavigationContext } from '../NavigationContext';

const MIN_SCROLL_POSITION = 120;
const MIN_SCROLL_HEIGHT = 1007;

export const NavigationHeader = () => {
    const { t } = useTranslation('translation');
    const navigationContext = useNavigationContext();
    const { scrollY } = useScrollPosition();

    const navigationHeaderClassMap = {
        'navigation-header': true,
        'navigation-header--is-collapsed': navigationContext.isCollapsed,
        'navigation-header--is-scrolled':
            scrollY > MIN_SCROLL_POSITION &&
            (document.querySelector('.app-main-layout') as HTMLDivElement)?.scrollHeight > MIN_SCROLL_HEIGHT,
    };

    const toggleCollapse = () => {
        navigationContext.setIsCollapsed(!navigationContext.isCollapsed);
    };

    const handleLogoClick = () => {
        if (navigationContext.collapseOnNavigation) {
            navigationContext.setIsCollapsed(true);
        }
    };

    const renderMenuButton = () => {
        const button = (icon: IconIdentifier) => (
            <ButtonTertiaryOnDarkS
                icon={icon}
                label={t('application.navigation.menuButtonLabel')}
                onClick={toggleCollapse}
            />
        );

        if (navigationContext.isCollapsed) {
            return button(IconIdentifier.HAMBURGER);
        }
        return button(IconIdentifier.CLOSE);
    };

    return (
        <section className={buildClassStringFromClassMap(navigationHeaderClassMap)}>
            <NavLink to={RoutePath.DASHBOARD} onClick={handleLogoClick}>
                <div className="navigation-header-img" />
            </NavLink>
            <div className="navigation-header__menu-btn">{renderMenuButton()}</div>
        </section>
    );
};
